import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Http, Response } from '@angular/http';
import { EclesialContaTransfModel } from '@app/base/model/eclesial-conta-transf.model';
import { EclesialUsuarioModel } from '@app/base/model/eclesial-usuario.model';
import { IAppConfig } from '@app/config/app-config.model';
import { LoginService } from '@app/features/login/service/login.service';
import { ChangeOrganismoService } from './../features/change-organismo/service/change-organismo.service';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class AppConfig {

    static settings: IAppConfig;
    static accessToken: string;
    static refreshToken: string;
    static isMitra: boolean = true;
    static organismoId: string;
    static organismoCodigo: string;
    static organismoNome: string;
    static usuario: EclesialUsuarioModel = new EclesialUsuarioModel();
    static isCuriaManutencaoContabilTodasParoquias: boolean;
    static manutencaoContabilTodasParoquias: boolean;
    static idContaTransfBanco: EclesialContaTransfModel = new EclesialContaTransfModel();
    static idContaTransfCaixa: EclesialContaTransfModel = new EclesialContaTransfModel();

    constructor(
        private http: HttpClient,
        private loginService: LoginService,
        private ChangeOrganismoService: ChangeOrganismoService,
    ) {
    }

    load() {
        
		const SERVER_DOMAIN = localStorage.getItem('serverDomain');
    	const JSON_FILE = `assets/config/config.json`;
    	const HOST_NAME = SERVER_DOMAIN ? SERVER_DOMAIN : 'eclesial';

        return new Promise<void>((resolve, reject) => {
			
            this.http.get(JSON_FILE).subscribe((response) => {
				
				response = JSON.parse(JSON.stringify(response).replace(/{HOST}/g, HOST_NAME))
                
				AppConfig.settings = <IAppConfig>response;

                let loginTokenString = localStorage.getItem('loginToken');

                if (loginTokenString === null) {

					//comentar para build

                    // if (location.href.includes('http://localhost:')) {
                    //     console.group('Novo login');
                    //     this.authenticate().then(
                    //         () => {
                    //             console.groupEnd();
                    //             resolve();
                    //         },
                    //         (error) => {
                    //             console.groupEnd();
                    //             reject(error);
                    //         },
                    //     );
                    // } else {
                    //     this._redirLogin();
					// }
					
					// descomentar para build
					this._redirLogin();

                } else {
                    try {
                        this.trocarOrganismo(loginTokenString).then(
                            () => {
                                // console.groupEnd();
                                resolve();
                            },
                            (error) => {
                                // console.groupEnd();
                                this._redirLogin();
                                reject(error);
                            },
                        );
                    } catch (error) {
                        // console.groupEnd();
                        this._redirLogin();
                        reject(`Error renovando login: ${error}`);
                    }
                }
            }),
			catchError((response: any) => {
                reject(`Could not load file '${JSON_FILE}': ${JSON.stringify(response)}`);
				return response;
            });
        });
    }

	//Comentar para build
    // private authenticate() {
    //     return new Promise<void>((resolve, reject) => {
    //         this.loginService.authenticate(AppConfig.settings).subscribe((result: any) => {

    //             AppConfig.setToken(result);

    //             this.loginService.getConfigNomenclatura(AppConfig.settings).subscribe((resultOrganismo) => {
    //                 AppConfig.setConfiguracoesParoquia(resultOrganismo);
    //             });

    //             resolve();
    //         }, (error) => {
    //             reject(error);
    //         });
    //     });
    // }

    private trocarOrganismo(loginTokenString) {
        return new Promise<void>((resolve, reject) => {
            let loginToken = JSON.parse(loginTokenString);

            let organismoId = loginToken.organismoId;
            let refreshToken = loginToken.refresh_token;
            let accessToken = loginToken.access_token;
            const licencaUso = loginToken.licencaUso;

            this.ChangeOrganismoService.trocarOrganismo(AppConfig.settings, organismoId, refreshToken).subscribe((result: any) => {
                this._refreshTokenHub({
                    token: accessToken,
                    newToken: result.access_token,
                }).subscribe();

                AppConfig.setToken({...result, licencaUso});

                this.loginService.getConfigNomenclatura(AppConfig.settings).subscribe((resultOrganismo) => {

                    AppConfig.setConfiguracoesParoquia(resultOrganismo);

                });

                // console.groupEnd();
                resolve();
            }, (error) => {
                reject(error);
            });
        });
    };

    private _refreshTokenHub(viewModel): Observable<any> {
		return this.http.post<any>(
			`${AppConfig.settings.env.apiEclesialIdentityHub}v1/Authentication/refreshtoken`,
			viewModel
		);
    }

    private _redirLogin(){
        const isNewExperience = localStorage.getItem('isNewExperience') == 'true';
        if (isNewExperience) {
            window.top.postMessage("tokenExpired", "*");
            return;
        }
        location.href = AppConfig.settings.env.urlLogin;
    }

    static setToken(result) {
        AppConfig.accessToken = result.access_token;
        AppConfig.refreshToken = result.refresh_token;
        AppConfig.organismoId = result.organismoId;
        AppConfig.organismoCodigo = result.organismoCodigo;
        AppConfig.organismoNome = result.organismoNome;
        AppConfig.usuario.email = result.usuarioEmail;
        AppConfig.usuario.login = result.usuarioLogin;
        AppConfig.usuario.nome = result.usuarioNome;
        AppConfig.isMitra = result.organismoIsMitra === 'true' ? true : false;

        AppConfig.idContaTransfBanco = result.idContaTransfBanco === 'null' ? null : JSON.parse(result.idContaTransfBanco);
        AppConfig.idContaTransfCaixa = result.idContaTransfCaixa === 'null' ? null : JSON.parse(result.idContaTransfCaixa);

        let manutencaoContabilTodasParoquias = window.localStorage.getItem('loginToken') ? (JSON.parse(window.localStorage.getItem('loginToken'))).manutencaoContabilTodasParoquias : '';

        AppConfig.manutencaoContabilTodasParoquias = manutencaoContabilTodasParoquias === 'true' ? true : false;

        AppConfig.isCuriaManutencaoContabilTodasParoquias = (AppConfig.manutencaoContabilTodasParoquias === true && AppConfig.isMitra === true) ? true : false;

        this.setTokenLocalStorage(result);
    }

    static setTokenLocalStorage(result) {
        localStorage.removeItem('loginToken');
        localStorage.setItem('loginToken', JSON.stringify(result));

        let permissoes = JSON.parse(result.permissoes);

        // TODO Remover quando o Eclesial Paróquia tiver removido
        localStorage.removeItem('permissions');
        localStorage.setItem('permissions', result.permissoes);

        localStorage.removeItem('permissionsAccounting');
        localStorage.setItem('permissionsAccounting', result.permissoesContabeis);

    }

    static setConfiguracoesParoquia(result) {
        localStorage.removeItem('configuracoes');
        localStorage.setItem('configuracoes', JSON.stringify(result));

        localStorage.setItem('sm-setmenu', 'top');
        localStorage.setItem('sgcp_exibirRascunho', 'sim');
    }
}